export class ErrorController {
    public static $inject: string[] = [
        "sitesService"
    ];

    constructor(public sitesService) {}
}
